import { j as r } from "./atoms-v218.js";
import { forwardRef as a } from "react";
import { ButtonSkeleton as x } from "./atoms-v21219.js";
import { Button as j, Content as h, RightContent as B } from "./atoms-v21220.js";
import { Icon as P } from "./atoms-v217.js";
import { getIconName as O } from "./atoms-v21221.js";
import { OtherPaymentsOnly as R, SecondaryOnlyBrands as N, PrimaryOnlyBrands as g } from "./atoms-v21222.js";
const w = a(
  ({
    ariaLabel: n = "",
    brand: o = "applePay",
    className: l,
    colorTheme: t = "light",
    disabled: f = !1,
    display: y = "inline",
    id: p,
    isFullRounded: u = !1,
    isSkeleton: s = !1,
    onClick: d,
    rightContent: i,
    size: m = "default",
    type: c = "button",
    variant: e = "primary"
  }, $) => (R.includes(o) && (e = "otherPayments"), e === "dueNow" && (N.includes(o) ? e = "secondary" : e = "primary"), e === "secondary" && g.includes(o) && (e = "primary"), s ? /* @__PURE__ */ r.jsx(
    x,
    {
      ariaLabel: n,
      brand: o,
      colorTheme: t,
      size: m,
      variant: e
    }
  ) : /* @__PURE__ */ r.jsx(
    j,
    {
      $brand: o,
      $colorTheme: t,
      $display: y,
      $isFullRounded: u,
      $isSkeleton: s,
      $size: m,
      $variant: e,
      "aria-label": n,
      className: l,
      disabled: f,
      id: p,
      onClick: d,
      ref: $,
      type: c,
      children: /* @__PURE__ */ r.jsxs(h, { $brand: o, children: [
        /* @__PURE__ */ r.jsx(P, { name: O({ brand: o }) }),
        i && /* @__PURE__ */ r.jsx(B, { $colorTheme: t, $size: m, $variant: e, children: i })
      ] })
    }
  ))
);
w.displayName = "PaymentButton";
export {
  w as PaymentButton
};
